var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyOnRailsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.188,
    height: 32,
    viewBox: "0 0 25.188 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.295,
    y1: 0.603,
    x2: 0.954,
    y2: 0.452,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0815e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.496,
    r: 0.505,
    gradientTransform: "translate(0 0.18) scale(1 0.638)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a94436"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled-1",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M4.4,33.633s.049-7.544.049-15.208c0-14.851-1.268-15.956,5.482-15.956H28.73V23.882c0,7.051,1.335,9.812-6.174,9.812S4.4,33.633,4.4,33.633Z",
    transform: "translate(-3.975 -2.085)",
    fill: "#a62c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M.095,2.752A3.892,3.892,0,0,1,2.344,4.733C3.388,6.475,8.928,20.024,8.928,20.024V9.007L3.789.777,5.235,2.514,7.964.295,4.433.06Z",
    transform: "translate(15.828 0.434)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M.211.138s7.95,5.23,11.8,6.259S19.88,8.538,19.88,8.538L10.731,30.719l3.933.158L19.8,18.359,19.641.058.21.142Z",
    transform: "translate(5.034 0.432)",
    opacity: 0.668,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M14.758,17.807l8.268,7.848L7.613,25.334a62.747,62.747,0,0,1-.32-7.368l.964-2.534,6.5,2.376Z",
    transform: "translate(-2.126 6.134)",
    fill: "rgba(255,255,255,0.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M24.372,33.7l-7.468-7.6-6.823-2.537-5.3-11.643L10.4,2.644,6.629,2.486,5.1,3.913,4.542,5.027l-.4,28.837L24.37,33.7Z",
    transform: "translate(-4.113 -2.075)",
    fill: "rgba(0,0,0,0.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M26.673,14.17a108.2,108.2,0,0,0-12.042,4.6c-4.5,2.219-6.9,7.607-6.9,7.607s9.633-.475,13.246-.317,5.3.158,5.622-4.833A45.033,45.033,0,0,0,26.673,14.17Z",
    transform: "translate(-1.839 5.335)",
    fill: "#83222d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M5.81,17.066v4.679H7.019V20.528l1.1,1.084H9.979L8.506,20.164s1.062-.016,1.138-1.528c0-1.387-1.062-1.568-2.284-1.568H5.811Zm1.268,1.27H8.12v.834H7.078Zm5.234-1.25c-.664,0-1.58.056-1.58,1.288v3.251h1.242v-.8h1.2V21.6h1.248V18.2c0-1.07-1.2-1.111-1.848-1.111h-.265Zm-.32,1.173h1.165v1.282H11.992Zm3.676-1.169h1.28v4.475H15.662Zm2.63.058v4.476h3.092V20.43H19.561v-3.3Zm7.185-.041v1.209H23.414v.434H24.3c.462,0,1.427-.02,1.427,1.407s-.664,1.505-2.008,1.505H22.091V20.574h1.866c.561,0,.593-.182.593-.338S24.262,20,23.678,20s-1.667-.284-1.667-1.392.56-1.527,1.684-1.527,1.787.02,1.787.02Z",
    transform: "translate(-3.055 7.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(1.512 1.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M7.419,24.48H18.1A22.359,22.359,0,0,1,16.332,14.3a8.237,8.237,0,0,1,6.7-7.33,4.115,4.115,0,0,1,3.411,1.111l.482-.714a10.115,10.115,0,0,0-7.185-2.813,10.818,10.818,0,0,0-8.513,6.139A28.583,28.583,0,0,0,7.82,19.408a15.686,15.686,0,0,0-.4,5.071ZM5.3,19.17l2.087.158-.361,2.059L5.05,21.152Zm3.288-4.357.561-1.544L7.3,12.556,6.7,14.22Zm2.61-5.31,1.083-1.268-1.406-.909L9.746,8.555Zm2.85-4.911.964,1.148,1.327-.751-.964-1.07Zm4.7-1.308.24,1.148,1.646-.04-.161-1.03Z",
    transform: "translate(-5.05 -3.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M19.785,4.037l-.04.714,1.123.593.242-.356ZM16.092,7.6l.523.948.762-.593-.161-.632ZM14.446,8.829l.8,1.195-.481.832L13.6,9.588ZM12.84,12.118l-.522,1.03L13.683,14.3l.323-1.308Zm-.56,3.605-.08,1.386,1.686.713-.08-1.308Zm.481,4.911.4,1.424,2.124.119-.763-1.544H12.754Z",
    transform: "translate(-0.516 -2.808)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M5.039,33.4q8.834.052,17.667.065c3.027,0,4.513-.487,5.2-1.593.589-.95.672-1.991.6-5.657-.016-.956-.024-1.523-.024-2.181V3h-18.4c-3.121,0-4.124.288-4.655,1.414s-.585,2.376-.487,8.807c.033,2.113.049,3.623.049,5.352q0,7.414-.049,14.829h.1Zm-.873.38v-.338q.013-2.194.021-4.39c.016-3.555.025-7.124.025-10.479,0-1.726-.015-3.231-.048-5.34-.1-6.637-.056-7.832.56-9.142.706-1.5,1.95-1.858,5.36-1.858H29.267v21.8c0,.653.008,1.216.024,2.169.07,3.85-.015,4.935-.719,6.07-.864,1.392-2.6,1.958-5.866,1.958q-8.835-.012-17.671-.065H4.163v-.388Z",
    transform: "translate(-4.124 -2.234)",
    fill: "#5e000e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyOnRailsIcon);
export default __webpack_public_path__ + "static/media/rubyOnRailsIcon.a5fbe1f944de1fd1dca36408e17ecdd9.svg";
export { ForwardRef as ReactComponent };